/**
 * List of events used by acco lister widget
 *
 */
export const accoListerEvents = {
  ACCO_LISTER_PRINTED: 'AccoLister.Printed',
  ACCO_LISTER_ITEM_CLICKED: 'AccoLister.ItemClicked',
  ACCO_LISTER_CTA_CLICKED: 'AccoLister.CtaClicked'
}
